import React from 'react';

import { ds } from '@/components/lib/design.system';
import { withOpacity } from '@/styles/styles';

import { PaymentTag } from './PaymentTag';

export const FastestTag = () => {
    return (
        <PaymentTag
            translationKey="fastest"
            color={ds.colorToken.text.accent.purple}
            backgroundColor={withOpacity(ds.colorValue.background.accent.purple.strong, 0.15)}
        />
    );
};
